export * from 'store/bolt/trackingV2.js';
// import * as base from 'store/bolt/trackingV2.js';
import { accessNested, asList, parseDate } from 'utils/utils';
import { maybeHandle } from 'utils/gdpr/maybeHandle';
// import formatDateTime from 'utils/formatDateTime';
import Store from 'store/store';
// import * as actions from 'store/actions';
import cached from 'utils/cached';

if (USE_TRACKING_V2) {

	const getPowsterCustomGA = cached(() => {
		let powsterCustomGA = Store.get().appData?.apis?.tracking?.powsterGATracking;
		return asList(powsterCustomGA).filter(id => id.startsWith('UA-') || id.startsWith('G-'));
	});

	// Powster Custom GA Tracking
	const debugMode = __IS_LOCAL__ || __IS_DEMO__;

	const firePowsterCustomEvent = (action, category, label, options) => {
		if (typeof powsterGtag !== 'function') {
			return;
		}

		let tagIds = getPowsterCustomGA();

		if (!tagIds || !tagIds.length) return;

		const store = Store.get();
		const region = accessNested(store, 'appData.meta.region.slug', '');
		const title = accessNested(store, 'appData.meta.title.locale', '');
		const studio = accessNested(store, 'appData.meta.studio.slug');
		const app = title + ' - ' + region.toUpperCase();

		const args = {
			send_to: tagIds,
			event_stream: app,
			event_category: category,
			event_label: label,
			event_region: region,
			event_studio: studio,
			region: region,
			allow_google_signals: false,
			debug_mode: debugMode
		};

		Object.assign(args, options);
		const powGtagCat = accessNested(store, 'appData.apis.tracking.powsterGATracking.trackingCategory', 'PERFORMANCE');
		maybeHandle(powGtagCat, () => window.powsterGtag('event', action, args), true);
	};

	const fireLionsgateTicketClick = (screening, theater) => {
		const store = Store.get();
		const locale = accessNested(store, 'appData.meta.title.locale', '');
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'movie_time_click',
			content_title: locale,
			theater_name: theater.name,
			showtime_date: screening.date,
			showtime_time: screening.time
		});
	};

	const fireLionsgateSelectTheater = (name) => {
		const store = Store.get();
		const locale = accessNested(store, 'appData.meta.title.locale', '');
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'theater_click',
			content_title: locale,
			theater_name: name
		});
	};

	const fireLionsgateConversion = (data) => {
		const locale = accessNested(Store.get(), 'appData.meta.title.locale', '');
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'aggregator_click',
			content_title: locale,
			click_text: data.provider,
			theater_name: data.theater.name,
			showtime_date: data.date,
			showtime_time: data.time
		});
	};
	
	const fireLionsgateTracking = () => {
		const store = Store.get();
		const lionsgateAdswerve_Old = accessNested(store, 'appData.apis.tracking.lionsgateAdswerve');
		const lionsgateAdswerve = accessNested(store, 'appData.options.lionsgateAdswerve');
		if (lionsgateAdswerve_Old || lionsgateAdswerve) {
			const locale = accessNested(store, 'appData.meta.title.locale', '');
			const { dxNumber, genres, distributionWindow } = lionsgateAdswerve_Old ? lionsgateAdswerve_Old : lionsgateAdswerve;

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'dataLayer-initialized',
				titleName: locale,
				dxNumbers: dxNumber,
				genre: genres,
				environment: 'prod',
				distributionWindow: distributionWindow,
				pageContentType: 'movie',
				siteType: 'standalone movie site'
			});
		}
	};

	Store.on('LANDING', () => {
		let store = Store.get();
		const lionsgateAdswerve_Old = accessNested(store, 'appData.apis.tracking.lionsgateAdswerve');
		const lionsgateAdswerve = accessNested(store, 'appData.options.lionsgateAdswerve');
		if (lionsgateAdswerve_Old || lionsgateAdswerve) {
			fireLionsgateTracking();
		}
	});

	Store.on('SELECT_THEATER', (theater, source, ticketType = 'tickets') => {
		let store = Store.get();
		const lionsgateAdswerve_Old = accessNested(store, 'appData.apis.tracking.lionsgateAdswerve');
		const lionsgateAdswerve = accessNested(store, 'appData.options.lionsgateAdswerve');
		if (lionsgateAdswerve_Old || lionsgateAdswerve) {
			const name = theater.name || '';
			const chain = accessNested(theater, 'chain.name', '');
			const concatChainName = name + '-' + chain;

			firePowsterCustomEvent(ticketType + '-select-theatre_chain', ticketType, concatChainName);
			fireLionsgateSelectTheater(name);
		}
	});

	// Use ticket conversion for all link outs - interstitial or not
	Store.on('SELECT_TIME', (data, page) => {
		let store = Store.get();
		const lionsgateAdswerve_Old = accessNested(store, 'appData.apis.tracking.lionsgateAdswerve');
		const lionsgateAdswerve = accessNested(store, 'appData.options.lionsgateAdswerve');
		if (lionsgateAdswerve_Old || lionsgateAdswerve) {
			if (!page) page = 'tickets';
			const { screening, theater } = data;
			if (!screening || !theater) {
				return;
			}
			firePowsterCustomEvent('tickets-interstitial', page, `${theater.name}_${theater.chain?.name}_${screening.date}_${screening.time}_${screening.format}`);

			fireLionsgateTicketClick(screening, theater);
		}
	});

	Store.on('TICKET_CONVERSION', (data, page) => {
		let store = Store.get();
		const lionsgateAdswerve_Old = accessNested(store, 'appData.apis.tracking.lionsgateAdswerve');
		const lionsgateAdswerve = accessNested(store, 'appData.options.lionsgateAdswerve');
		if (lionsgateAdswerve_Old || lionsgateAdswerve) {
			// let parsedDate = parseDate(data.date);
			if (!page) page = 'tickets';
			// const { ticketType = 'tickets' } = data;
			// Keeping this for now for legacy reasons
			// firePowsterCustomEvent(ticketType + '-select-calendar_date', page, data.date);

			// firePowsterCustomEvent(ticketType + '-conversion', 'tickets', data.conversion, {
			// 	date: data.date,
			// 	day: formatDateTime(parsedDate, 'dddd'),
			// 	time: data.time,
			// 	format: data.format,
			// 	provider: data.provider,
			// 	source: data.source,
			// });

			fireLionsgateConversion(data);
		}
	});
}